import React from 'react';
import './Footer.css';

function DetFooter() {
    return (
        <footer className="footer__det">
            <div>
                <a id="footerLink"
                   rel="noopener noreferrer"
                   target="_blank"
                   href="https://education.nsw.gov.au/"
                   className="footer__det--link">NSW Department of Education 2026</a>
            </div>
            <div className="footer__det--support">
                <div>
                    <a className="footer__det--link" target="_blank" rel="noopener noreferrer" href="https://prcsupport.freshdesk.com/support/home">
                        Support
                    </a>
                </div>
                <div>
                    <a className="footer__det--link" target="_blank" rel="noopener noreferrer" href="https://prcsupport.freshdesk.com/support/solutions/articles/6000081939">Contact Us</a>
                </div>
            </div>
        </footer>
    );
}

export default DetFooter;
